<template>
        <div class="table-responsive table-fix-head" style="max-height: 450px; overflow-y: auto" v-loading="loading">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th style="width: 80px;">ID</th>
                        <th>Title</th>
                        <th style="max-width: 400px;">Categories</th>
                        <th style="width: 140px;">States</th>
                        <th style="width: 140px;">Campaign</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="j in jobs">
                    <td>{{ j.id }}</td>
                    <td>{{ j.title }}<br>
                        <i>{{ j.admin_description }}</i>
                    </td>
                    <td>
                        <div v-for="tag in j.categories" style="display:inline-block; margin-bottom:5px;">
                            <span class="label"
                                  :class="{ 'label-default' : (tag != 'Owner Operators'), 'label-primary' : (tag == 'Owner Operators') }"
                                  style="margin-right:5px">{{ tag }}</span>
                        </div>
                    </td>
                    <td>{{ j.state_code_list }}<br>
                        States: {{ j.state_count }}
                    </td>
                    <td>
                        <template v-if="campaign_options">
                            <el-select v-model="campaigns[j.id]" @change="changeCampaign(j.id)">
                                <el-option v-for="campaign in campaign_options"
                                :key="`cmp-${campaign.id}`"
                                :label="campaign.name"
                                :value="campaign.id"></el-option>
                            </el-select>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
</template>

<script>
    export default {
        props: [
            'employer_id',
            'campaign_id',
            'campaign_options',
        ],
        data() {
            return {
                jobs: [],
                campaigns: {},
                loading: false,
            };
        },
        watch: {
            campaign_id() {
                this.refresh();
            }
        },
        methods: {
            refresh() {
                this.jobs = [];
                this.loading = true;
                return axios.get(url(`admin/employer/${this.employer_id}/campaign/${this.campaign_id}/jobs`))
                    .then(response => {
                        this.jobs = response.data.jobs;

                        this.campaigns = {};
                        const self = this;
                        this.jobs.forEach(function (job) {
                            self.$set(self.campaigns, job.id, self.campaign_id);
                        });
                        this.loading = false;
                    });
            },
            changeCampaign(jobId) {
                this.loading = true;
                axios.post(url(`admin/employer/${this.employer_id}/assign-campaign`), {
                    job_id: jobId,
                    campaign_id: this.campaigns[jobId],
                }).then(response => {
                    this.$emit('updated');
                    return this.refresh();
                });
            },
        },
        mounted() {
            this.refresh();
        },
    };
</script>
<style>
.table-fix-head thead th {
    position: sticky;
    top: 0;
    background: white;
}
</style>